import { render } from "./SourceOverlay.vue?vue&type=template&id=1d00f01f"
import script from "./SourceOverlay.vue?vue&type=script&lang=js"
export * from "./SourceOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__